module.exports = __webpack_public_path__ + "img/header.afce4c60.png";